import { render, staticRenderFns } from "./PartnerLabelSetting.vue?vue&type=template&id=7fb1a10f&scoped=true&"
import script from "./PartnerLabelSetting.vue?vue&type=script&lang=js&"
export * from "./PartnerLabelSetting.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLabelSetting.vue?vue&type=style&index=0&id=7fb1a10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb1a10f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb1a10f')) {
      api.createRecord('7fb1a10f', component.options)
    } else {
      api.reload('7fb1a10f', component.options)
    }
    module.hot.accept("./PartnerLabelSetting.vue?vue&type=template&id=7fb1a10f&scoped=true&", function () {
      api.rerender('7fb1a10f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/PartnerLabelSetting.vue"
export default component.exports